export default __webpack_public_path__ + "static/media/flower.ed7b6cc6.svg";